/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Cancel_SuccessInputs */

const vi_toast_order_cancel_success = /** @type {(inputs: Toast_Order_Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy đơn hàng thành công`)
};

/**

* @param {Toast_Order_Cancel_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_cancel_success = /** @type {((inputs?: Toast_Order_Cancel_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Cancel_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_cancel_success(inputs)
});